import React from 'react';

//components
import BasicButton from '../../global/buttons/BasicButton';
import ElementTypeInformation from '../FormElements/elements/ElementTypeInformation';

//interfaces
import { IFormElementButton } from '../interfaces/IFormBuilderButtons';


const FormElementMenuButton = ({ elementType, ariaLabel, onButtonClick }: IFormElementButton ) => {    
    return (
        <BasicButton 
            className='form-element-menu-button' 
            content={
                <ElementTypeInformation elementType={elementType} />
            } 
            ariaLabel={ariaLabel} 
            onButtonClick={onButtonClick} 
        />
    );
};

export default FormElementMenuButton